module.exports = __webpack_public_path__ + "img/mishmesh_yes.20d2c6e8.png";